import React, { useState, useEffect } from 'react';
import { Spin, message, Table } from 'antd';
import { asignacionPresupuestal, propiacion_municipal, sistemaGeneralParticipaciones } from '../../../services/perfiles/conponentesServices';
import './tablaG.css';

const InversionComponente = ({ municipioId }) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [dataP, setDataPresupuestal] = useState([]);
    const [dataParticipaciones, setDataParticiapaciones] = useState([]);

    useEffect(() => {
        if (municipioId) {
            fetchData();
            asignacionPresupuesto();
            sistemaParticipaciones();
        }
    }, [municipioId]);

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await propiacion_municipal(municipioId);
            if (response && response.status === 200) {
                const fetchedData = response.data;
                if (Array.isArray(fetchedData)) {
                    setData(fetchedData);
                } else {
                    throw new Error('Fetched data is not an array');
                }
            } else {
                throw new Error('Invalid response from server');
            }
        } catch (error) {
            message.error('Error loading data');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };
    const asignacionPresupuesto = async () => {
        setLoading(true);
        try {
            const response = await asignacionPresupuestal(municipioId);
            if (response && response.status === 200) {
                const fetchedData = response.data;
                if (Array.isArray(fetchedData)) {
                    setDataPresupuestal(fetchedData);
                } else {
                    throw new Error('Fetched data is not an array');
                }
            } else {
                throw new Error('Invalid response from server');
            }
        } catch (error) {
            message.error('Error loading data');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };
    const sistemaParticipaciones = async () => {
        setLoading(true);
        try {
            const response = await sistemaGeneralParticipaciones(municipioId);
            if (response && response.status === 200) {
                const fetchedData = response.data;
                if (Array.isArray(fetchedData)) {
                    
                    setDataParticiapaciones(fetchedData);
                    const totalUltimaDoceava = fetchedData.reduce((sum, item) => sum + parseFloat(item.ultima_doceava || 0), 0);
                    const totalOnceDoceavas = fetchedData.reduce((sum, item) => sum + parseFloat(item.once_doceavas|| 0), 0);
                    const total = fetchedData.reduce((sum, item) => sum + parseFloat(item.total || 0), 0);
    
                    // Agregar la fila total
                    const totalRow = {
                        id_asignacion: 'total',
                        nombre: 'TOTAL',
                        ultima_doceava: totalUltimaDoceava,
                        once_doceavas: totalOnceDoceavas,
                        total: total,
                    };
    
                    // Agregar la fila total a los datos
                    setDataParticiapaciones([...fetchedData, totalRow]);
                } else {
                    throw new Error('Fetched data is not an array');
                }
            } else {
                throw new Error('Invalid response from server');
            }
        } catch (error) {
            message.error('Error loading data');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };
    const columnspresu = [
        {
            title: 'ASIGNACIONES',
            dataIndex: 'asignacion',
            key: 'asignacion',
            className: 'filaP'
        },
        {
            title: 'PESOS CORRIENTES ($)',
            dataIndex: 'pesos_corrientes',
            key: 'pesos_corrientes',
            className: 'filaP'
        },
    ];
    const columnsparti = [
        {
            title: 'CONCEPTO',
            dataIndex: 'nombre',
            key: 'nombre',
            className: 'filaP',

        },
        {
            title: 'ÚLTIMA DOCEAVA ($)',
            dataIndex: 'ultima_doceava',
            key: 'ultima_doceava',
            className: 'filaP',

        },
        {
            title: 'ONCE DOCEAVA ($)',
            dataIndex: 'once_doceavas',
            key: 'once_doceavas',
            className: 'filaP',

        },
        {
            title: 'TOTAL ($)',
            dataIndex: 'total',
            key: 'total',
            className: 'filaP',
            
        },

    ];


    const columns = [
        { title: 'Apropiación Presupuestal Bienio actual	 ', dataIndex: 'apropiacion_bienio_actual', key: 'apropiacion_bienio_actual', className: 'filaP' },
        { title: 'Aprobación de Proyectos Bienio actual	 ', dataIndex: 'aprobacion_bienio_actual', key: 'aprobacion_bienio_actual', className: 'filaP' },
        { title: 'Recursos Indicativos para aprobación de proyectos', dataIndex: 'recursos_indicativos', key: 'recursos_indicativos', className: 'filaP' },
    ];

    return (
        <div >
            <h1>COMPONENTE DE INVERSIÓN PÚBLICA</h1>
            <Spin spinning={loading}>
                <div className="section">
                    <h3>Apropiación del Municipío</h3>
                    <Table
                        columns={columns}
                        dataSource={data}
                        rowKey="idapropiacion"
                        pagination={false}
                    />
                </div>
            </Spin>
            <div>
                <h3>Sistema General de regalías SGR– Asignación presupuestal
                </h3>
                {loading ? (
                    <Spin size="large" />
                ) : (
                    <Table columns={columnspresu} dataSource={dataP} rowKey="id_asignacion" />
                )}
            </div>
            <div>
                <h3> Reportes Sistema General de Participaciones - SGP
                </h3>
                {loading ? (
                    <Spin size="large" />
                ) : (
                    <Table columns={columnsparti} dataSource={dataParticipaciones} rowKey="id_asignacion" />
                )}
            </div>
        </div>
    );
};

export default InversionComponente;
